import { render, staticRenderFns } from "./EditBeneficiaryComponent.vue?vue&type=template&id=ae9af914"
import script from "./EditBeneficiaryComponent.vue?vue&type=script&lang=js"
export * from "./EditBeneficiaryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports